// extracted by mini-css-extract-plugin
export var logo = "_lt-2";
export var logoWrapper = "_lt-1";
export var strip = "_lt-0";